import React, { Component } from 'react'
import { connect } from 'react-redux'
// import '../../../styles/checkout/mainStyle.css'
import { selectMode } from '../../../actions/commonActions'

import MonerisConfigImage from '../../../images/MonerisConfig.png'

import {updateTxnTotal,
        updateApiToken,
        updateStoreId, 
        updateCheckoutId,
        resetConfiguration,
        setPreloadRequestMessage
         } from '../../../actions/checkoutActions'

export class Overview extends Component { 
  state = {
    isSubmitClicked: false,
    topRef: React.createRef(),
    tokenRef:React.createRef(),
    fraudRef:React.createRef(),
    sizeRef:React.createRef(),
    multiRef:React.createRef()
  };

  // componentDidMount() {
  //   this.props.selectMode('integration_guide');
  // }

  onScrollToTop() {
    this.state.topRef.current.scrollIntoView()
    window.document.body.scrollIntoView(true)
  }

  onScrollToken(){
    this.state.tokenRef.current.scrollIntoView()
    window.document.body.scrollIntoView(true)
  }
  onScrollFraud(){
    this.state.fraudRef.current.scrollIntoView()
    window.document.body.scrollIntoView(true)
  }

  onScrollSize(){
    this.state.sizeRef.current.scrollIntoView()
    window.document.body.scrollIntoView(true)
  }

  onScrollMult(){
    this.state.multiRef.current.scrollIntoView()
    window.document.body.scrollIntoView(true)
  }

  
  renderInteractiveTool() {
    const {  storeId, apiToken, checkoutId, txnTotal } = this.props;
    return (
      <div className= "leftContents2">  
          <div  ref={this.state.topRef} >
          <h3>Moneris Checkout Overview</h3>
            <p style={{ paddingLeft: '1vw'}}>Moneris Checkout gives e-commerce merchants a simple and secure way to process payments by integrating a Moneris-hosted payment module into the merchant checkout page.
            </p>
          <h3>System and Skills Requirements</h3>
          <div style={{ paddingLeft: '1vw'}}>
            <p>In order to integrate with Moneris Checkout as a merchant, you must have:</p>
              <ul>
                  <li>An e-commerce website with a back-end server</li>
              </ul> 
            <p>For development, you should have some understanding of the following:</p>
              <ul>
                  <li>JavaScript</li>
                  <li>JSON</li>
                  <li>Server-side programming</li>
              </ul> 
            <p>Additionally, for Google Pay™ integration, all your front-end web pages must use the HTTPS protocol.</p>
          </div>
          <h3>Configuration</h3>
            <div style={{ paddingLeft: '1vw'}}>
              <p>The first step is to configure your Moneris  Checkout page in the Moneris Merchant Resource Center (MRC).<br></br>
              In the initial stage of development, you create a test configuration in the testing MRC. Once the solution is ready to be deployed to production, you must create a new, separate configuration for the production environment in the production MRC.<br></br>
              The checkout ID is the key value that is generated after the configuration is completed and used within the Preload Request in order to identify the specific Moneris Checkout configuration.</p>
              <p>To get the checkout ID and start configuring your page, do the following:</p>          
                <ol>
                  <li>Log into the Merchant Resource Center at one of the following URLs (according to your stage of development)<br></br>
                  Testing: <a href="https://esqa.moneris.com/mpg" target="_blank" rel="noopener noreferrer">https://esqa.moneris.com/mpg</a><br></br>
                  Production: <a href="https://www3.moneris.com/mpg" target="_blank" rel="noopener noreferrer">https://www3.moneris.com/mpg</a><br></br>
                  </li>
                  <li>In the Admin menu, select Moneris Checkout Config</li>
                  <li>Click the Create Profile button</li>
                  <li>Follow the on-screen steps to complete the configuration</li>
                </ol>
              </div>
          <div>
            <table style={{marginLeft:"1vw"}}>
              <tbody>
                <tr key={'storeId'}>
                  <td>
                    <label>Store ID:</label>
                  </td>
                  <td>
                    <form>
                      <label>
                          <input
                          name="StoreId"
                          type="text"
                          style={{width:"90%"}}
                          value={storeId}
                          onChange={text => {this.props.updateStoreId(text.target.value)}} />
                      </label>
                      <br />
                    </form>
                  </td>
                </tr>
                <tr key={'apiToken'}>
                  <td>
                    <label>API Token:</label>
                  </td>
                  <td>
                    <form>
                      <label>
                          <input
                          name="ApiToken"
                          type="text"
                          style={{width:"90%"}}
                          value={apiToken}
                          onChange={text => this.props.updateApiToken(text.target.value)} />
                      </label>
                      <br />
                    </form>
                  </td>
                </tr>
                <tr key={'checkoutId'}>
                  <td>
                    <label>Checkout ID:</label>
                  </td>
                  <td>
                    <form>
                      <label>
                          <input
                          name="CheckOutId"
                          style={{width:"90%"}}
                          type="text"
                          value={checkoutId}
                          onChange={text => this.props.updateCheckoutId(text.target.value)} />
                      </label>
                      <br />
                    </form>
                  </td>
                </tr>
                <tr key={'Transaction Total'}>
                  <td>
                    <label>Transaction Total:</label>
                  </td>
                  <td>
                    <form>
                      <label>
                          <input
                          name="Transaction Total"
                          style={{width:"90%"}}
                          type="text"
                          value={txnTotal}
                          onChange={text => this.props.updateTxnTotal(text.target.value)} />
                      </label>
                      <br />
                    </form>
                  </td>
                </tr>
                </tbody>
              </table>
              <div className="uploadButton2" onClick={() => this.setState({ isSubmitClicked: true})}  style={{ marginBottom:"auto",marginLeft: "1vw", marginTop:"2vh",float:"none" }} >Submit Changes</div>
            <div id = {this.state.isSubmitClicked ? "snackbarShow" : "snackbar"}> Changes have been applied </div>
            <h3>Additional Features in Moneris Checkout</h3>
            <div className="afterTitle2">
              <p>There are other features of the Moneris Checkout page that you can enable using the configurator in the Merchant Resource Center. They include:
                <br></br>     
              </p>
              <ol>
                <li onClick={() => this.onScrollToken()} style={{color: '#00a1cb', cursor:"pointer"}}>Tokenization of credentials</li>
                <li onClick={() => this.onScrollFraud()} style={{color: '#00a1cb', cursor:"pointer"}}>Fraud tool behaviour</li>
                <li onClick={() => this.onScrollSize()} style={{color: '#00a1cb', cursor:"pointer"}}>Window sizing</li>
                <li onClick={() => this.onScrollMult()} style={{color: '#00a1cb', cursor:"pointer"}}>Multi-Currency Pricing</li>
              </ol>
              <div style={{listStyleType: "none", paddingleft:"0vw", paddingInlineStart: "0.1vw"}}>   
                      <span ref={this.state.tokenRef}></span>                 
                      <h3>Tokenization of Credentials With Moneris Checkout</h3>  
                      <div className="afterTitle2">
                        <p>You can use Moneris Checkout to store a cardholder's credentials in the Moneris Vault and receive a token that represents those credentials for use in future transactions. You can also use Moneris Checkout to update the credentials associated with the token.</p>
                        <p>If you want to tokenize credentials in Moneris Checkout transactions, you select the <b>Tokenize Card</b> option in the Merchant Resource Center. For updating existing tokens, select <b>Vault Update Card</b>.</p>
                        <p>
                            For more information, see the Merchant Resource
                            Center documentation available for download on the 
                            Moneris developer portal at:
                        </p>
                        <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a>
                        <br/>
                        <h4 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.2rem'}}>Tokens and Pay by Token</h4>
                        <p>With tokenization enabled, Moneris Checkout also enables you to allow returning customers to select stored payment cards on the payment page. The customer's payment cards need to be already tokenized and stored in the Moneris Vault to be referenced in the Preload request and displayed to the customer when they get to the payment page.</p>
                        <p>In the Preload request, Moneris Checkout will accept a token composed of up to three pairs of <b>data key</b> and <b>issuer ID</b>, each one representing the cardholder's payment card stored in the Moneris Vault.</p>
                        <p>For more information about these fields in the Preload, see Preload Request</p>                   
                      </div>

                      <span ref={this.state.fraudRef}></span>
                      <h3>Fraud Tools in Moneris Checkout</h3> 
                      <div className="afterTitle2">
                        <p>Several tools to mitigate the risk of fraud are 
                            available for transactions in Moneris Checkout, 
                            including:
                        </p>
                        <ul>
                            <li>AVS</li>
                            <li>CVD</li>
                            <li>3-DSecure</li>
                            <li>Kount</li>
                        </ul> 
                        <p>
                            To select which of these tools to use when performing 
                            transactions with Moneris Checkout, go to your Moneris 
                            Checkout configurator in the Moneris Merchant Resource 
                            Center under the Payment Security section.<br></br>
                            For more information, see the Merchant Resource 
                            Center documentation available for download on the 
                            Moneris developer portal at:
                        </p>
                        <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a>                       
                        
                        <p>
                            If you select Kount as a fraud tool in Moneris Checkout and 
                            your company has its own Enterprise service account from Kount, 
                            you will need to include your Kount Merchant ID, Kount API Key 
                            and Kount Web- site ID when you configure your Moneris Checkoutstore 
                            in the Merchant Resource Center.<br></br>
                            If you are using Moneris's basic fraud service package and do
                            not have your own Kount enterprise account, 
                            you do not require this information.
                        </p>
                        <p>
                            Moneris Checkout can be configured to automatically proceed 
                            with or deny transactions as a result of a risk assessment it makes 
                            based on the responses it receives from the selected fraud tools.<br/>
                            When you check the box for auto decision-making, you also can choose 
                            whether each fraud tool's ana- lysis will be treated by Moneris as an 
                            optional or mandatory factor in the decision to approve or deny the transaction.<br/>   
                            This information applies to all fraud tools with the following exception:<br/>
                          </p>
                          <ul>
                            <li>3-D Secure, which is always mandatory if enabled</li>
                          </ul> 
                      </div>

                      <span ref={this.state.sizeRef}></span>
                      <h3>Window Size in Moneris Checkout</h3>
                      <p className="afterTitle2">You can customize the appearance of the Moneris Checkout window 
                          presented to the customer on their web browser, including how 
                          much of the browser window will be taken up by Moneris Checkout.<br/>
                          The default sizing behaviour of the Moneris Checkout window is 
                          full-screen, i.e., Moneris Checkout fills the entire web page. 
                          You can alter this behaviour to present the customer with a 
                          windowed view instead.<br/>
                          If you do not use the full-screen option, you must define the 
                          size of the &lt;div&gt; for the window ed view. For more information, 
                          see 2.3 Preparing Your Client-Side Checkout Page.<br/>
                          You configure the sizing along with other aspects of the Moneris 
                          Checkout window in the Merchant Resource Center.
                      </p>

                      <span ref={this.state.multiRef}></span>
                      <h3>Multi-Currency Pricing in Moneris Checkout</h3> 
                      <div className="afterTitle2">
                        <p>You can configure Moneris Checkout to price goods and services in a 
                            variety of foreign currencies, while continuing to receive settlement 
                            and reporting in Canadian dollars.<br/>
                            If you want to use Multi-Currency Pricing (MCP) in Moneris Checkout 
                            transactions, you can enable the Multi-Currency Pricing option 
                            in the Merchant Resource Center. MCP is only available for Visa 
                            and Mastercard.<br/>
                            If Multi-Currency Pricing is enabled, the following 
                            features are not supported:
                        </p>
                        <ul>
                            <li>Recurring Billing</li>
                            <li>Gift Cards</li>
                            <li>3-D Secure 1.0</li>
                            <li>Google Pay TM</li>
                        </ul> 
                        For more information, see the Merchant Resource
                                Center documentation available for download on the 
                                Moneris developer portal at:
                        <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a> 
                      </div>
                  </div>
              </div>
            </div>
            <i onClick={() => this.onScrollToTop()} className={"material-icons scrollToTop"}>{'arrow_circle_up'}</i>
        </div>
      </div>
      )
  }

  renderDocument() {
    return (
      <div className= "stepPageContainer">  
          <div  ref={this.state.topRef} >
          <h3 className="stepPageTitle">Moneris Checkout Overview</h3>
          <p style={{ paddingLeft: '1vw'}}>Moneris Checkout gives e-commerce merchants a simple and secure way to process payments by integrating a Moneris-hosted payment module into the merchant checkout page.</p>
          
          <h3>System and Skills Requirements</h3>
          <div style={{ paddingLeft: '1vw'}}>
            <p>In order to integrate with Moneris Checkout as a merchant, you must have:</p>
            <ul>
                <li>An e-commerce website with a back-end server</li>
            </ul> 
            <p>For development, you should have some understanding of the following:</p>
            <ul>
                <li>JavaScript</li>
                <li>JSON</li>
                <li>Server-side programming</li>
            </ul> 
            <p>Additionally, for Google Pay™ integration, all your front-end web pages must use the HTTPS protocol.</p>
          </div>

          <h3 ref={this.state.configRef}>Configuration</h3>
            <div style={{ paddingLeft: '1vw'}}>
              <p>The first step is to configure your Moneris  Checkout page in the Moneris Merchant Resource Center (MRC).</p>
              <p>In the initial stage of development, you create a test configuration in the testing MRC.</p>
              <p>Once the solution is ready to be deployed to production, you must create a new, separate configuration for the production environment in the production MRC.</p>
              <p>The checkout ID is the key value that is generated after the configuration is completed and used within the Preload Request in order to identify the specific Moneris Checkout configuration.</p>
              <p>To get the checkout ID and start configuring your page, do the following:</p>          
                <ol>
                  <li>Log into the Merchant Resource Center at one of the following URLs (according to your stage of development)<br></br>
                    <ul>
                      <li>Testing: <a href="https://esqa.moneris.com/mpg" target="_blank" rel="noopener noreferrer">https://esqa.moneris.com/mpg</a></li>
                      <li>Production: <a href="https://www3.moneris.com/mpg" target="_blank" rel="noopener noreferrer">https://www3.moneris.com/mpg</a></li>
                    </ul>
                  </li>
                  <li>In the Admin menu, select Moneris Checkout Config</li>
                  <li>Click the Create Profile button</li>
                  <li>Follow the on-screen steps to complete the configuration</li>
                </ol>
                <p>For more information, see the Merchant Resource Center documentation available for download on the Moneris developer portal at:
                </p>  
                <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a>                       
              </div>

          <div>
            <h3>Moneris Checkout Transaction Process Flow</h3>
            <img ref={this.state.imgRef} style={{ width: '100%', height: '800px'}} src={MonerisConfigImage} alt='' />
              <h3 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.2rem'}}>Additional Features in Moneris Checkout</h3>
              <div className="afterTitle2">
                <p>There are other features of the Moneris Checkout page that you can enable using the configurator in the Merchant Resource Center. They include:
                  <br></br>     
                </p>
                <ol>
                  <li onClick={() => this.onScrollToken()} style={{color: '#00a1cb', cursor:"pointer"}}>Tokenization of Credentials With Moneris Checkout</li>
                  <li onClick={() => this.onScrollFraud()} style={{color: '#00a1cb', cursor:"pointer"}}>Fraud Tools in Moneris Checkout</li>
                  <li onClick={() => this.onScrollSize()} style={{color: '#00a1cb', cursor:"pointer"}}>Window Size in Moneris Checkout</li>
                  <li onClick={() => this.onScrollMult()} style={{color: '#00a1cb', cursor:"pointer"}}>Multi-Currency Pricing in Moneris Checkout</li>
                </ol>
                <ol style={{listStyleType: "none", paddingleft:"0vw", paddingInlineStart: "0.1vw"}}>   
                        <span ref={this.state.tokenRef}></span>               
                        <h3 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.1rem'}}>1. Tokenization of Credentials With Moneris Checkout</h3>  
                        <div className="afterTitle2">
                          <p>
                              You can configure Moneris Checkout to store a cardholder's 
                              credentials in the Moneris Vault and receive a token 
                              that represents those credentials for use in 
                              future transactions. You can also use Moneris Checkout to update the credentials associated with the token.</p>
                              <p>
                              If you want to tokenize credentials in Moneris Checkout 
                              transactions, you select the <b>Tokenize Card</b> option 
                              in the Merchant Resource Center. For updating existing tokens, select <b>Vault Update Card</b></p>
                              <p>
                              For more information, see the Merchant Resource
                              Center documentation available for download on the 
                              Moneris developer portal at:
                          </p>
                          <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a> 
                          <br/>
                          <h3>Tokens and Pay by Token</h3>
                          <p>With tokenization enabled, Moneris Checkout also enables you to allow returning customers to select stored payment cards on the payment page. The customer's payment cards need to be already tokenized and stored in the Moneris Vault to be referenced in the Preload request and displayed to the customer when they get to the payment page.</p>
                          <p>In the Preload request, Moneris Checkout will accept a token composed of up to three pairs of <b>data key</b> and <b>issuer ID</b>, each one representing the cardholder's payment card stored in the Moneris Vault.</p>
                          <p>For more information about these fields in the Preload, see Preload Request</p>                        
                        </div>
                      
                        <span ref={this.state.fraudRef}></span>
                        <h3 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.1rem'}}>2. Fraud Tools in Moneris Checkout</h3> 
                        <div className="afterTitle2">
                          <p>Several tools to mitigate the risk of fraud are 
                              available for transactions in Moneris Checkout, 
                              including:
                          </p>
                          <ul>
                              <li>AVS</li>
                              <li>CVD</li>
                              <li>3-DSecure</li>
                              <li>Kount</li>
                          </ul> 
                          <p>
                              To select which of these tools to use when performing 
                              transactions with Moneris Checkout, go to your Moneris 
                              Checkout configurator in the Moneris Merchant Resource 
                              Center under the Payment Security section.<br></br>
                              For more information, see the Merchant Resource 
                              Center documentation available for download on the 
                              Moneris developer portal at:
                          </p>
                          <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a>                       
                          <p>
                              If you select Kount as a fraud tool in Moneris Checkout and 
                              your company has its own Enterprise service account from Kount, 
                              you will need to include your Kount Merchant ID, Kount API Key 
                              and Kount Web- site ID when you configure your Moneris Checkoutstore 
                              in the Merchant Resource Center.<br></br>
                              If you are using Moneris's basic fraud service package and do
                              not have your own Kount enterprise account, 
                              you do not require this information.
                          </p>
                          <p>
                              Moneris Checkout can be configured to automatically proceed 
                              with or deny transactions as a result of a risk assessment it makes 
                              based on the responses it receives from the selected fraud tools.<br/>
                              When you check the box for auto decision-making, you also can choose 
                              whether each fraud tool's ana- lysis will be treated by Moneris as an 
                              optional or mandatory factor in the decision to approve or deny the transaction.<br/>   
                              This information applies to all fraud tools with the following exception:<br/>
                            </p>
                            <ul>
                              <li>3-D Secure, which is always mandatory if enabled</li>
                            </ul> 
                        </div>

                        <span ref={this.state.sizeRef}></span>
                        <h3 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.1rem'}}>3. Window Size in Moneris Checkout</h3> 
                        <p className="afterTitle2">You can customize the appearance of the Moneris Checkout window 
                            presented to the customer on their web browser, including how 
                            much of the browser window will be taken up by Moneris Checkout.<br/>
                            The default sizing behaviour of the Moneris Checkout window is 
                            full-screen, i.e., Moneris Checkout fills the entire web page. 
                            You can alter this behaviour to present the customer with a 
                            windowed view instead.<br/>
                            If you do not use the full-screen option, you must define the 
                            size of the &lt;div&gt; for the window ed view. For more information, 
                            see 2.3 Preparing Your Client-Side Checkout Page.<br/>
                            You configure the sizing along with other aspects of the Moneris 
                            Checkout window in the Merchant Resource Center.
                        </p>

                        <span ref={this.state.multiRef}></span>
                        <h3 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.1rem'}}>4. Multi-Currency Pricing in Moneris Checkout</h3> 
                        <div className="afterTitle2">
                          <p>You can configure Moneris Checkout to price goods and services in a 
                              variety of foreign currencies, while continuing to receive settlement 
                              and reporting in Canadian dollars.<br/>
                              If you want to use Multi-Currency Pricing (MCP) in Moneris Checkout 
                              transactions, you can enable the Multi-Currency Pricing option 
                              in the Merchant Resource Center. MCP is only available for Visa 
                              and Mastercard.<br/>
                              If Multi-Currency Pricing is enabled, the following 
                              features are not supported:
                          </p>
                          <ul>
                              <li>Recurring Billing</li>
                              <li>Gift Cards</li>
                              <li>3-DSecure 1.0</li>
                              <li>Google PayTM</li>
                          </ul> 
                          <p>For more information, see the Merchant Resource Center documentation available for download on the Moneris developer portal at:</p>
                          <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a> 
                        </div>
                    </ol>
                </div>
              </div>
            </div>
            {/* <i onClick={() => this.onScrollToTop()} className={"material-icons scrollToTop"}>{'arrow_circle_up'}</i> */}
      </div>
      )

  }

  render() {
    const { mode } = this.props;
    if(mode === 'interactive_tool')
        return this.renderInteractiveTool();
    else if(mode === 'integration_guide')
        return this.renderDocument();
    else {
        return null;
    }
  }
}

const mapStateToProps = state => {
  const { mode } = state.common.sideNav;
  const { storeId, apiToken, checkoutId,txnTotal} = state.checkout.main;
  return { storeId, apiToken, checkoutId,txnTotal,mode};
}



export default connect(mapStateToProps,{selectMode,updateApiToken, updateStoreId, resetConfiguration, updateCheckoutId,updateTxnTotal,setPreloadRequestMessage})(Overview)
